import { render, staticRenderFns } from "./UiArrayInput.vue?vue&type=template&id=cda9dfe0"
import script from "./UiArrayInput.vue?vue&type=script&lang=js"
export * from "./UiArrayInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports